import reducer from './reducer';

export {
  setCurrentBreakpoint,
  setBreakpoints,
  listenForBreakpointChanges,
  setIsMobile,
} from './actions';

export default reducer;
